exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Pager__pager__15Jlv{-ms-flex:none;flex:none;display:-ms-flexbox;display:flex}.Pager__backIcon__piXQf{transform:rotate(180deg)}", "", {"version":3,"sources":["/mnt/d/asofts/vvs/cirrus/Cirrus/frontend/src/components/controls/src/components/controls/Pager.scss"],"names":[],"mappings":"AAAA,qBACI,cAAU,AAAV,UAAU,AACV,oBAAa,AAAb,YAAa,CAChB,AAED,wBAEI,wBAAyB,CAC5B","file":"Pager.scss","sourcesContent":[".pager {\n    flex: none;\n    display: flex;\n}\n\n.backIcon {\n    //background: url(assets/controls/right.svg) no-repeat center;\n    transform: rotate(180deg);\n}\n.forwardIcon {\n    //background: url(assets/controls/right.svg) no-repeat center;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"pager": "Pager__pager__15Jlv",
	"backIcon": "Pager__backIcon__piXQf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/Pager.scss
// module id = ./node_modules/css-loader/index.js??ref--1-2!./node_modules/sass-loader/lib/loader.js??ref--1-3!./src/components/controls/Pager.scss
// module chunks = 0